import {
  type ExecuteRequest,
  type ExecuteResponse,
  executeReport,
} from '@/lib/api/reports-client.js';
import { useMutation } from '@tanstack/react-query';

export function useExecute(tenantReportId: string) {
  return useMutation<ExecuteResponse, Error, ExecuteRequest>({
    mutationFn: (body: ExecuteRequest) => executeReport(tenantReportId, body),
  });
}
